import { SelectBox } from 'components'

const STORE_FORMAT = [{ storeformat_name: 'SUPERMARKET' }]

type StoreFormatProps = {
  storeFormatState: {
    region: string[]
    storeFormat: string[]
  }
  onChange(storeFormat: string[], isDefaultAll?: boolean): void
}

export const SelectStoreFormat = (props: StoreFormatProps) => {
  const { storeFormatState, onChange } = props
  const { storeFormat } = storeFormatState

  const handleStoreFormatChange = (
    selectedStoreFormats: string,
    selectedStoreFormatsText: string,
    isDefaultAll?: boolean
  ) => {
    onChange([selectedStoreFormats], isDefaultAll)
  }

  return (
    <div className="w-full sm:w-64">
      <SelectBox
        placeholder="Select store format"
        label="Store Format *"
        id="store-format"
        disabled={true}
        value={storeFormat?.[0] ?? ''}
        onChange={handleStoreFormatChange}
        options={STORE_FORMAT.map((item) => ({
          text: item.storeformat_name,
          value: item.storeformat_name,
        }))}
      />
    </div>
  )
}
